var _path, _path2, _linearGradient, _path3, _linearGradient2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    width: 70,
    height: 70,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1c94f9",
    d: "M27.2,43c-0.5,0.8-1.2,1.5-2.2,2c-4,2-15,3-15,13v4h44v-4c0-10-11-11-15-13c-1-0.5-1.7-1.2-2.2-2H27.2z",
    className: "color1c94f9 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c94f9",
    d: "M32,25c0-3.4,1.2-6.6,3.1-9.1c-0.5-0.1-0.9-0.2-1.4-0.3c-0.1,0-0.2,0-0.2,0c-0.1,0-0.3,0-0.4,0 c-0.3,0-0.6,0-0.9,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.3,0-0.6,0-0.9,0c-0.1,0-0.3,0-0.4,0 c-0.1,0-0.2,0-0.2,0C24.6,16.4,20,21.4,20,27.5c0,8,5.4,17,12,17c0,0,0,0,0,0c0,0,0,0,0,0c3.4,0,6.5-2.4,8.7-5.9 C35.6,36.3,32,31.1,32,25z",
    className: "color1c94f9 svgShape"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 38,
    x2: 56,
    y1: 25,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#034a7a",
    className: "stopColor034a7a svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002f49",
    className: "stopColor002f49 svgShape"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M40,27h5v5c0,1.1,0.9,2,2,2s2-0.9,2-2v-5h5c1.1,0,2-0.9,2-2s-0.9-2-2-2h-5v-5c0-1.1-0.9-2-2-2s-2,0.9-2,2v5h-5 c-1.1,0-2,0.9-2,2S38.9,27,40,27z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 64,
    y1: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#034a7a",
    className: "stopColor034a7a svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002f49",
    className: "stopColor002f49 svgShape"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M22.4,48.1c1.4-0.4,2.5-0.8,3.5-1.3c0.9-0.4,1.6-1,2.2-1.7c1.3,0.6,2.6,0.9,3.9,0.9c3.3,0,6.6-1.8,9.1-5.1 C43,41.6,44.9,42,47,42c9.4,0,17-7.6,17-17S56.4,8,47,8c-3.5,0-6.7,1-9.4,2.8c-0.4-1.6-1-3.2-2-4.5C33.2,2.4,28.8,0,24,0 c-7.7,0-14,6.3-14,14c0,6.1,2.7,12.3,6.6,15.9c-0.2,0.1-0.3,0.3-0.5,0.3c-0.7,0.3-1.8,0.7-3,1.1C8.2,32.9,0,35.6,0,45v4 c0,1.1,0.9,2,2,2h8.1C8.8,52.8,8,55.1,8,58v4c0,1.1,0.9,2,2,2h44c1.1,0,2-0.9,2-2v-4c0-9.3-8-12-12.4-13.4c-1-0.3-2.2,0.2-2.5,1.3 c-0.3,1,0.2,2.2,1.3,2.5c5.1,1.7,9.6,3.7,9.6,9.6v2H12v-2C12,52,16.5,50,22.4,48.1z M32,42c-5,0-10-7.6-10-15c0-5.5,4.5-10,10-10 c0,0,0,0,0,0c-1.3,2.4-2,5.1-2,8c0,5.8,3,11,7.5,14.1C35.8,40.9,33.9,42,32,42z M60,25c0,7.2-5.8,13-13,13s-13-5.8-13-13 s5.8-13,13-13S60,17.8,60,25z M14,14c0-5.5,4.5-10,10-10c3.4,0,6.5,1.7,8.3,4.5c0.9,1.3,1.4,2.9,1.6,4.6C33.3,13,32.7,13,32,13 c-7.2,0-13.2,5.5-13.9,12.6C15.6,22.6,14,18.2,14,14z M4,45c0-6,4.5-8,10.4-9.9c1.4-0.4,2.5-0.8,3.5-1.3c0.3-0.2,0.7-0.4,1-0.6 c1.1,4,3.2,7.4,5.8,9.6c-0.2,0.1-0.3,0.3-0.5,0.4c-0.7,0.3-1.8,0.7-3,1.1c-1.9,0.6-4.4,1.5-6.6,2.8C14.3,47,14.2,47,14,47H4V45z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleuser);
export default __webpack_public_path__ + "static/media/multipleuser.80dde03338c36f237ef95f839755733d.svg";
export { ForwardRef as ReactComponent };